var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-autocomplete',{staticStyle:{"display":"block"},attrs:{"fetch-suggestions":_vm.querySearchAsync,"placeholder":_vm.placeholder,"custom-item":"my-item-zh","popper-class":"my-autocomplete"},on:{"select":_vm.handleSelect},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }